module.exports = __webpack_public_path__ + "img/jewellery@2x.434dba3.webp";